import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const AppButton = styled.a`
  align-items: center;
  display: flex;
  height: 42px;
  justify-content: center;
  max-width: 140px;
  width: 100%;
`
const Icon = styled.img`
  margin-right: 10px;
`

const MobileStoreImage = ( { storeLogo, storeLogoAlt, url } ) => {
  return (
    <AppButton href={ url }>
      <Icon
        alt={ storeLogoAlt }
        loading="lazy"
        src={ storeLogo }
      />
    </AppButton>
  )
}

MobileStoreImage.propTypes = {
  'name': PropTypes.string.isRequired,
  'storeLogo': PropTypes.string.isRequired,
  'storeLogoAlt': PropTypes.string.isRequired,
  'url': PropTypes.string.isRequired
}

export default MobileStoreImage
